<div class="checkmark">
  <div class="checkmark-inner">
    <span class="fas fa-fw fa-check"></span>
    <ng-container *ngIf="text">
      <span class="checkmark-text">{{text}}</span>
    </ng-container>
  </div>
</div>